/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemAnswerAiCorrectionViewModel } from "../types/ExamItemAnswerAiCorrectionViewModel.ts";

export const examItemAnswerAiCorrectionViewModelSchema = z.object({
  answerId: z.optional(z.number().int()),
  suggestedGrade: z.optional(z.number()),
  contentScore: z.optional(z.number()),
  completenessScore: z.optional(z.number()),
  cohesionScore: z.optional(z.number()),
  grammarScore: z.optional(z.number()),
  justification: z.string().nullish(),
  strengths: z.array(z.string()).nullish(),
  improvements: z.array(z.string()).nullish(),
}) as unknown as ToZod<ExamItemAnswerAiCorrectionViewModel>;
